import PropTypes from 'prop-types'

function TextField({
  name,
  forwardedRef,
  type,
  onChange,
  label,
  value,
  additionalClass,
  isError,
  errorLabel,
  leftIcon,
  rightIcon,
  style,
  extraFieldClass = '',
  onlyIntegers = false,
  ...props
}) {
  const allowOnlyNumbers = (event) => {
    const charCode = event.which ? event.which : event.keyCode
    const value = event.target.value

    // Allow only one decimal point
    if (charCode === 46) {
      if (onlyIntegers) {
        event.preventDefault()
      }
      // 46 is the keyCode for '.'
      if (value.includes('.')) {
        event.preventDefault()
      }
      return
    }
    // Allow numbers only
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      event.preventDefault()
    }
  }

  const allowOnlyNumbersAndLetters = (event) => {
    const charCode = event.which ? event.which : event.keyCode
    if (
      (charCode >= 65 && charCode <= 90) || // A-Z
      (charCode >= 97 && charCode <= 122) || // a-z
      (charCode >= 48 && charCode <= 57) // 0-9
    ) {
      return true
    } else {
      event.preventDefault()
      return false
    }
  }

  const checkPressedKey = (event) => {
    if (type === 'number') {
      allowOnlyNumbers(event)
    } else if (type === 'noPunctuationMarks') {
      allowOnlyNumbersAndLetters(event)
    } else {
      return null
    }
  }

  return (
    <div
      className={`field ${extraFieldClass} ${leftIcon ? 'field-icon' : ''} ${
        rightIcon ? 'field-icon-right' : ''
      }`}
      style={style}
    >
      {label && (
        <label htmlFor={name} className={`label ${isError && 'is-danger'}`}>
          {label}
        </label>
      )}
      <div className="control">
        {leftIcon || null}
        <input
          className={`input ${additionalClass || ''} ${isError ? 'is-danger' : ''}`}
          ref={forwardedRef}
          value={value}
          onChange={onChange}
          name={name}
          type={type}
          onKeyPress={checkPressedKey}
          {...props}
        />
        <span className="icon-wrapper">{rightIcon || null}</span>
        {errorLabel && isError && <span className={'label--error'}>{errorLabel}</span>}
      </div>
    </div>
  )
}

TextField.propTypes = {
  name: PropTypes.string.isRequired,
  forwardedRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  ]),
  label: PropTypes.string,
  placeholder: PropTypes.string,
  additionalClass: PropTypes.string,
  disabled: PropTypes.bool,
  type: PropTypes.string,
  onlyIntegers: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  min: PropTypes.number,
  max: PropTypes.number,
  maxLength: PropTypes.number,
  leftIcon: PropTypes.object,
  rightIcon: PropTypes.object,
  isError: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  errorLabel: PropTypes.string,
  style: PropTypes.object,
  extraFieldClass: PropTypes.string,
}

TextField.defaultValue = {
  isError: false,
  type: 'text',
}

export default TextField
